import { embedDashboard } from '@preset-sdk/embedded';
import { call, SagaGenerator } from 'typed-redux-saga';
import { insightsApiClient } from '@owl-frontend/api-client';
import { asyncActionStateMatchers, invoke } from '@owl-frontend/redux';
import insightsDetailsSlice from './interface';

export const INSIGHTS_CONTAINER_ID = 'advanced-insights-container';
function* renderAdvancedInsightsDashboard(action: {
  payload: { mountPoint: HTMLElement };
}): SagaGenerator<void> {
  yield* call(embedDashboard, {
    id: 'd3700d73-1655-4550-a02b-c6e66885d222',
    supersetDomain: 'https://a4769ca7.us2a.app.preset.io',
    mountPoint: action.payload.mountPoint,
    fetchGuestToken: insightsApiClient.advancedInsights.guestToken,
    dashboardUiConfig: {
      hideTitle: true,
    },
  });
}

function* renderLtdBucketsDashboard(action: {
  payload: { mountPoint: HTMLElement };
}): SagaGenerator<void> {
  yield* call(embedDashboard, {
    id: '36263990-58e9-4876-b264-7a59ea180c37',
    supersetDomain: 'https://a4769ca7.us2a.app.preset.io',
    mountPoint: action.payload.mountPoint,
    fetchGuestToken: insightsApiClient.ltdBuckets.guestToken,
    dashboardUiConfig: {
      hideTitle: true,
    },
  });
}

const slice = insightsDetailsSlice
  .addAsyncSagas({
    fetchOverview: invoke(insightsApiClient.insights.overview),
    fetchFindings: invoke(insightsApiClient.insights.findings),
    fetchTeam: invoke(insightsApiClient.insights.team),
    renderAdvancedInsightsDashboard,
    renderLtdBucketsDashboard,
  })
  .addReducers({
    'fetchOverview/fulfilled': (state, action) => {
      const { startTime, endTime } = action.meta.arg;
      const key = `${startTime}-${endTime}`;

      state.overview = { ...state.overview, [key]: action.payload };
    },
    'fetchFindings/fulfilled': (state, action) => {
      const { startTime, endTime } = action.meta.arg;
      const key = `${startTime}-${endTime}`;

      state.findings = { ...state.findings, [key]: action.payload };
    },
    'fetchTeam/fulfilled': (state, action) => {
      const { startTime, endTime } = action.meta.arg;
      const key = `${startTime}-${endTime}`;

      state.team = { ...state.team, [key]: action.payload };
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
